module.exports = __webpack_public_path__ + "img/monster-1.4411d52b.png";